import type { ThemeVariant } from "../types";

/**
 * 1. Oxford Navy Variant
 * Traditional authoritative navy with classic serif typography.
 */
export const oxfordNavyTheme: ThemeVariant = {
  id: "theme-oxford-navy",
  name: "Oxford Navy",
  styleRecipe: "sapphire-scholar",
  colorPalette: "oxford-navy",
  fontPairing: "serif-classic",
  backgroundStyle: "solid",
  animationLevel: "subtle",
  layoutDensity: "standard",
  cornerRadius: "subtle",
  typographyScale: "academic",
  effects: {
    hoverLift: true,
  },
};

/**
 * 2. Sapphire Modern Variant
 * Clean modern executive blue with crisp sans-serif hierarchy.
 */
export const sapphireModernTheme: ThemeVariant = {
  id: "theme-sapphire-modern",
  name: "Sapphire Modern",
  styleRecipe: "sapphire-scholar",
  colorPalette: "ocean-blue",
  fontPairing: "modern-sans",
  backgroundStyle: "solid",
  animationLevel: "subtle",
  layoutDensity: "standard",
  cornerRadius: "subtle",
  typographyScale: "modern",
  effects: {
    hoverLift: true,
  },
};

/**
 * 3. Obsidian Executive Variant
 * Authoritative dark graphite canvas with brushed champagne accents.
 */
export const obsidianExecutiveTheme: ThemeVariant = {
  id: "theme-obsidian-executive",
  name: "Obsidian Executive",
  styleRecipe: "obsidian-executive",
  colorPalette: "obsidian-executive",
  fontPairing: "modern-sans",
  backgroundStyle: "solid",
  animationLevel: "subtle",
  layoutDensity: "compact",
  cornerRadius: "subtle",
  typographyScale: "editorial",
  effects: {
    ambientGlow: true,
    hoverLift: true,
  },
};

/**
 * 4. Swiss Monochrome Variant
 * High-contrast black and white modernist typography with zero distraction.
 */
export const swissMonochromeTheme: ThemeVariant = {
  id: "theme-swiss-monochrome",
  name: "Swiss Monochrome",
  styleRecipe: "porcelain-swiss",
  colorPalette: "minimal-monochrome",
  fontPairing: "minimal",
  backgroundStyle: "solid",
  animationLevel: "none",
  layoutDensity: "compact",
  cornerRadius: "none",
  typographyScale: "academic",
};

/**
 * 5. Cyber Technical Variant
 * Data-rich teal on dark canvas with monospace code accents.
 */
export const cyberTechnicalTheme: ThemeVariant = {
  id: "theme-cyber-technical",
  name: "Cyber Technical",
  styleRecipe: "cyber-research",
  colorPalette: "cyber-teal",
  fontPairing: "technical",
  backgroundStyle: "dot-grid",
  animationLevel: "expressive",
  layoutDensity: "compact",
  cornerRadius: "subtle",
  typographyScale: "modern",
  effects: {
    glassmorphism: true,
    ambientGlow: true,
  },
};

/**
 * 6. Aurora Vibrant Variant
 * Luminous gradient accents with contemporary display typography.
 */
export const auroraVibrantTheme: ThemeVariant = {
  id: "theme-aurora-vibrant",
  name: "Aurora Vibrant",
  styleRecipe: "aurora-showcase",
  colorPalette: "aurora",
  fontPairing: "cyber-modern",
  backgroundStyle: "subtle-gradient",
  animationLevel: "expressive",
  layoutDensity: "spacious",
  cornerRadius: "rounded",
  typographyScale: "modern",
  effects: {
    glassmorphism: true,
    hoverLift: true,
  },
};

/**
 * 7. Botanical Warm Variant
 * Natural sage greens and warm parchment with editorial serif typography.
 */
export const botanicalWarmTheme: ThemeVariant = {
  id: "theme-botanical-warm",
  name: "Botanical Warm",
  styleRecipe: "editorial-atelier",
  colorPalette: "coastal",
  fontPairing: "editorial",
  backgroundStyle: "solid",
  animationLevel: "subtle",
  layoutDensity: "spacious",
  cornerRadius: "subtle",
  typographyScale: "editorial",
  effects: {
    hoverLift: true,
  },
};

/**
 * 8. Academic Royal Variant
 * Deep imperial amethyst and formal typography for endowed scholars.
 */
export const academicRoyalTheme: ThemeVariant = {
  id: "theme-academic-royal",
  name: "Academic Royal",
  styleRecipe: "editorial-atelier",
  colorPalette: "royal-amethyst",
  fontPairing: "serif-classic",
  backgroundStyle: "solid",
  animationLevel: "subtle",
  layoutDensity: "standard",
  cornerRadius: "subtle",
  typographyScale: "academic",
  effects: {
    hoverLift: true,
  },
};

export const ALL_THEMES: ThemeVariant[] = [
  oxfordNavyTheme,
  sapphireModernTheme,
  obsidianExecutiveTheme,
  swissMonochromeTheme,
  cyberTechnicalTheme,
  auroraVibrantTheme,
  botanicalWarmTheme,
  academicRoyalTheme,
];
